import { useQuery } from '@tanstack/react-query'
import { useAuthenticatedUserId } from './useAuthenticatedUserId'
import { IPreApprovedList } from '../interfaces/models/societies.interfaces'
import { userQueries } from '../api/users'
import { societyQueries } from '../api/societies'

export const usePreApprovedList = (): (IPreApprovedList & {
  societyId: string
})[] => {
  const userId = useAuthenticatedUserId() as string

  const { data: user } = useQuery(userQueries.getUser(userId))
  const { data: preApprovedSocieties } = useQuery(
    societyQueries.getUserPreaprovedSocieties({ userEmail: user?.email })
  )

  const preApprovedList =
    preApprovedSocieties?.flatMap(
      (society) =>
        society.preApprovedList?.map((approved) => ({
          ...approved,
          societyId: society._id,
        })) || []
    ) || []

  const userPreApprovedByEmail = preApprovedList.filter(
    (approved) => approved.userEmail === user?.email
  )

  return userPreApprovedByEmail
}
